// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__52MTw","active":"tab_active__QRsYV"};